import { objectKeys } from 'src/utils/objectKeys';
import { objectEntries } from 'src/utils/objectEntries';
import { AlertResultExport } from '../../types/AlertResults';
import { MultiSelectionItem } from 'src/components/common/MultiSelectionList';

export type ColumnId = keyof AlertResultExport.ListItem;

export const exportHeaders = {
  sourceOwnerName: 'Source Site',
  categoryName: 'Source Category Path',
  sourceManufacturerName: 'Source Manufacturer Name',
  sourceProductName: 'Source Product Name',
  uniqueIdentifier: 'Source Unique ID',
  sourceRegionName: 'Source Region',
  sourceRegularPrice: 'Source Regular Price',
  sourceLowestPrice: 'Source Lowest Price',
  sourceLowestPriceType: 'Source Lowest Price Type', // Output as “Regular Price”, “Sale Price”, etc
  sourceProductUrl: 'Source Product URL',
  matchType: 'Match Type',
  sourceCompetitorPriceVariance: 'Source Competitor Price Variance',
  sourceCompetitorLowestPriceVariance: 'Source Competitor Lowest Price Variance',
  competitorOwnerName: 'Competitor Site',
  competitorManufacturerName: 'Competitor Manufacturer Name',
  competitorProductName: 'Competitor Product Name',
  competitorRegionName: 'Competitor Region',
  competitorSellerName: 'Competitor Sold By',
  competitorFulfillerName: 'Competitor Fulfilled By',
  competitorRegularPrice: 'Competitor Regular Price',
  competitorLowestPrice: 'Competitor Lowest Price',
  competitorLowestPriceType: 'Competitor Lowest Price Type', // Output as “Regular Price”, “Sale Price”, etc
  competitorProductUrl: 'Competitor Product URL',
} as const satisfies Record<ColumnId, string>;

export const columnOptions: MultiSelectionItem[] = objectEntries(exportHeaders).map(([value, label]) => ({
  value,
  label,
}));

export const defaultColumnIds: ColumnId[] = objectKeys(exportHeaders);
